import { isNotDefined } from '@sgme/fp';
import type { FC } from 'react';
import * as ReactIntl from 'react-intl';

export const FormattedNumber: FC<
  ReactIntl.FormatNumberOptions & { value?: Nullable<number>; tabIndex?: number }
> = props => {
  if (isNotDefined(props.value)) {
    return null;
  } else {
    const definedProps = props as ReactIntl.FormatNumberOptions & { value: number; tabIndex?: number };
    return <ReactIntl.FormattedNumber {...definedProps}></ReactIntl.FormattedNumber>;
  }
};
